import { render, staticRenderFns } from "./MaintainingWeight.vue?vue&type=template&id=0aa047af&"
import script from "./MaintainingWeight.vue?vue&type=script&lang=js&"
export * from "./MaintainingWeight.vue?vue&type=script&lang=js&"
import style0 from "./MaintainingWeight.vue?vue&type=style&index=0&id=0aa047af&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports